import React from "react";

const PrivacyTerms = () => {
    return (
        <html>
            <body>
                <p>
                    <span>The following terms and conditions govern all use of the </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694791000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        &nbsp;website and all content, services and products available at or through
                        the website, including, but not limited to,
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694791000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>&nbsp;Forum Software, </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694792000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>&nbsp;Support Forums and the </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694792000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        &nbsp;Hosting service (&ldquo;Hosting&rdquo;), (taken together, the
                        Website). The Website is owned and operated by Stichting SingularityNET
                        (&ldquo;SingularityNET&rdquo;). The Website is offered subject to your
                        acceptance without modification of all of the terms and conditions contained
                        herein and all other operating rules, policies (including, without
                        limitation,
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694793000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>&rsquo;s </span>
                    <span>
                        <a href="https://community.singularitynet.io/privacy&amp;sa=D&amp;ust=1563446694793000">
                            Privacy Policy
                        </a>
                    </span>
                    <span>and </span>
                    <span>
                        <a href="https://community.singularitynet.io/faq&amp;sa=D&amp;ust=1563446694793000">
                            Community Guidelines
                        </a>
                    </span>
                    <span>
                        ) and procedures that may be published from time to time on this Site by
                        SingularityNET (collectively, the &ldquo;Agreement&rdquo;).
                    </span>
                </p>
                <p>
                    <span>
                        Please read this Agreement carefully before accessing or using the Website.
                        By accessing or using any part of the website, you agree to become bound by
                        the terms and conditions of this agreement. If you do not agree to all the
                        terms and conditions of this agreement, then you may not access the Website
                        or use any services. If these terms and conditions are considered an offer
                        by SingularityNET, acceptance is expressly limited to these terms. The
                        Website is available only to individuals who are at least 13 years old.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%231&amp;sa=D&amp;ust=1563446694794000">
                        1. Your SingularityNET.io Account
                    </a>
                </h2>
                <p>
                    <span>
                        If you create an account on the Website, you are responsible for maintaining
                        the security of your account and you are fully responsible for all
                        activities that occur under the account. You must immediately notify
                        SingularityNET of any unauthorized uses of your account or any other
                        breaches of security. SingularityNET will not be liable for any acts or
                        omissions by you, including any damages of any kind incurred as a result of
                        such acts or omissions.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%232&amp;sa=D&amp;ust=1563446694795000">
                        2. Responsibility of Contributors
                    </a>
                </h2>
                <p>
                    <span>
                        If you post material to the Website, post links on the Website, or otherwise
                        make (or allow any third party to make) material available by means of the
                        Website (any such material, &ldquo;Content&rdquo;), You are entirely
                        responsible for the content of, and any harm resulting from, that Content.
                        That is the case regardless of whether the Content in question constitutes
                        text, graphics, an audio file, or computer software. By making Content
                        available, you represent and warrant that:
                    </span>
                </p>
                <ul>
                    <li>
                        <span>
                            the downloading, copying and use of the Content will not infringe the
                            proprietary rights, including but not limited to the copyright, patent,
                            trademark or trade secret rights, of any third party;
                        </span>
                    </li>
                    <li>
                        <span>
                            if your employer has rights to intellectual property you create, you
                            have either (i) received permission from your employer to post or make
                            available the Content, including but not limited to any software, or
                            (ii) secured from your employer a waiver as to all rights in or to the
                            Content;
                        </span>
                    </li>
                    <li>
                        <span>
                            you have fully complied with any third-party licenses relating to the
                            Content, and have done all things necessary to successfully pass through
                            to end users any required terms;
                        </span>
                    </li>
                    <li>
                        <span>
                            the Content does not contain or install any viruses, worms, malware,
                            Trojan horses or other harmful or destructive content;
                        </span>
                    </li>
                    <li>
                        <span>
                            the Content is not spam, is not machine- or randomly-generated, and does
                            not contain unethical or unwanted commercial content designed to drive
                            traffic to third party sites or boost the search engine rankings of
                            third party sites, or to further unlawful acts (such as phishing) or
                            mislead recipients as to the source of the material (such as spoofing);
                        </span>
                    </li>
                    <li>
                        <span>
                            the Content is not pornographic, does not contain threats or incite
                            violence, and does not violate the privacy or publicity rights of any
                            third party;
                        </span>
                    </li>
                    <li>
                        <span>
                            your content is not getting advertised via unwanted electronic messages
                            such as spam links on newsgroups, email lists, blogs and websites, and
                            similar unsolicited promotional methods;
                        </span>
                    </li>
                    <li>
                        <span>
                            your content is not named in a manner that misleads your readers into
                            thinking that you are another person or company; and
                        </span>
                    </li>
                    <li>
                        <span>
                            you have, in the case of Content that includes computer code, accurately
                            categorized and/or described the type, nature, uses, and effects of the
                            materials, whether requested to do so by SingularityNET or otherwise.
                        </span>
                    </li>
                </ul>
                <h2>
                    <a href="https://community.singularitynet.io/tos%233&amp;sa=D&amp;ust=1563446694797000">
                        3. User Content License
                    </a>
                </h2>
                <p>
                    <span>User contributions are licensed under a </span>
                    <span>
                        <a href="http://creativecommons.org/licenses/by-nc-sa/3.0/deed.en_US&amp;sa=D&amp;ust=1563446694798000">
                            Creative Commons Attribution-NonCommercial-ShareAlike 3.0 Unported
                            License
                        </a>
                    </span>
                    <span>
                        . Without limiting any of those representations or warranties,
                        SingularityNET has the right (though not the obligation) to, in
                        SingularityNET&rsquo;s sole discretion (i) refuse or remove any content
                        that, in SingularityNET&rsquo;s reasonable opinion, violates any
                        SingularityNET policy or is in any way harmful or objectionable, or (ii)
                        terminate or deny access to and use of the Website to any individual or
                        entity for any reason, in SingularityNET&rsquo;s sole discretion.
                        SingularityNET will have no obligation to provide a refund of any amounts
                        previously paid.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%234&amp;sa=D&amp;ust=1563446694798000">
                        4. Payment and Renewal
                    </a>
                </h2>
                <h3>General Terms</h3>
                <p>
                    <span>
                        Optional paid services or upgrades may be available on the Website. When
                        utilizing an optional paid service or upgrade, you agree to pay
                        SingularityNET the monthly or annual subscription fees indicated. Payments
                        will be charged on a pre-pay basis on the day you begin utilizing the
                        service or upgrade and will cover the use of that service or upgrade for a
                        monthly or annual subscription period as indicated. These fees are not
                        refundable.
                    </span>
                </p>
                <h3>Automatic Renewal</h3>
                <p>
                    <span>
                        Unless you notify SingularityNET before the end of the applicable
                        subscription period that you want to cancel a service or upgrade, your
                        subscription will automatically renew and you authorize us to collect the
                        then-applicable annual or monthly subscription fee (as well as any taxes)
                        using any credit card or other payment mechanisms we have on record for you.
                        Subscriptions can be canceled at any time.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%235&amp;sa=D&amp;ust=1563446694800000">
                        5. Services
                    </a>
                </h2>
                <h3>Hosting, Support Services</h3>
                <p>
                    <span>
                        Optional Hosting and Support services may be provided by SingularityNET
                        under the terms and conditions for each such service. By signing up for a
                        Hosting/Support or Support services account, you agree to abide by such
                        terms and conditions.
                    </span>
                </p>
                <h3>HTTPS</h3>
                <p>
                    <span>
                        We offer HTTPS as a paid add-on. By signing up and using a custom domain
                        on{" "}
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694801000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        , you authorize us to act on the domain name registrant&rsquo;s behalf (by
                        requesting the necessary certificates, for example) for the sole purpose of
                        providing HTTPS on your site.
                    </span>
                </p>
                <h3>Enterprise</h3>
                <p>
                    <span>
                        Enterprise Hosting services are provided by SingularityNET.Preformatted text
                        under the terms and conditions for each such service, which is determined by
                        a customer-specific contract. By signing up for an Enterprise Hosting
                        account you agree to abide by such terms and conditions.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%236&amp;sa=D&amp;ust=1563446694802000">
                        6. Responsibility of Website Visitors
                    </a>
                </h2>
                <p>
                    <span>
                        SingularityNET has not reviewed, and cannot review, all of the material,
                        including computer software, posted to the Website, and cannot therefore be
                        responsible for that material&rsquo;s content, use or effects. By operating
                        the Website, SingularityNET does not represent or imply that it endorses the
                        material there posted, or that it believes such material to be accurate,
                        useful or non-harmful. You are responsible for taking precautions as
                        necessary to protect yourself and your computer systems from viruses, worms,
                        Trojan horses, and other harmful or destructive content. The Website may
                        contain content that is offensive, indecent, or otherwise objectionable, as
                        well as content containing technical inaccuracies, typographical mistakes,
                        and other errors. The Website may also contain material that violates the
                        privacy or publicity rights or infringes the intellectual property and other
                        proprietary rights, of third parties, or the downloading, copying or use of
                        which is subject to additional terms and conditions, stated or unstated.
                        SingularityNET disclaims any responsibility for any harm resulting from the
                        use by visitors of the Website, or from any downloading by those visitors of
                        content there posted.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%237&amp;sa=D&amp;ust=1563446694803000">
                        7. Content Posted on Other Websites
                    </a>
                </h2>
                <p>
                    <span>
                        We have not reviewed, and cannot review, all of the material, including
                        computer software, made available through the websites and webpages to which
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694803000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>&nbsp;links, and that link to </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694804000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>. SingularityNET does not have any control over those non - </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694804000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        websites and webpages, and is not responsible for their contents or their
                        use. By linking to a non -
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694804000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        &nbsp;website or webpage, SingularityNET does not represent or imply that it
                        endorses such website or webpage. You are responsible for taking precautions
                        as necessary to protect yourself and your computer systems from viruses,
                        worms, Trojan horses, and other harmful or destructive content.
                        SingularityNET disclaims any responsibility for any harm resulting from your
                        use of
                    </span>
                    <span>
                        <a href="http://non-singularitynet.io/&amp;sa=D&amp;ust=1563446694805000">
                            non-SingularityNET.io
                        </a>
                    </span>
                    <span>&nbsp;websites and webpages.</span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%238&amp;sa=D&amp;ust=1563446694805000">
                        8. Copyright Infringement and DMCA Policy
                    </a>
                </h2>
                <p>
                    <span>
                        As SingularityNET asks others to respect its intellectual property rights,
                        it respects the intellectual property rights of others. If you believe that
                        material located on or linked to by
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694806000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        violates your copyright, and if this website resides in the USA, you are
                        encouraged to notify SingularityNET in accordance with
                        SingularityNET&rsquo;s
                    </span>
                    <span>
                        <a href="http://en.wikipedia.org/wiki/Digital_Millennium_Copyright_Act&amp;sa=D&amp;ust=1563446694806000">
                            Digital Millennium Copyright Act
                        </a>
                    </span>
                    <span>
                        &nbsp;(&ldquo;DMCA&rdquo;) Policy. SingularityNET will respond to all such
                        notices, including as required or appropriate by removing the infringing
                        material or disabling all links to the infringing material. SingularityNET
                        will terminate a visitor&rsquo;s access to and use of the Website if, under
                        appropriate circumstances, the visitor is determined to be a repeat
                        infringer of the copyrights or other intellectual property rights of
                        SingularityNET or others. In the case of such termination, SingularityNET
                        will have no obligation to provide a refund of any amounts previously paid
                        to SingularityNET.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%239&amp;sa=D&amp;ust=1563446694807000">
                        9. Intellectual Property
                    </a>
                </h2>
                <p>
                    <span>
                        This Agreement does not transfer from SingularityNET to you any
                        SingularityNET or third party intellectual property, and all right, title
                        and interest in and to such property will remain (as between the parties)
                        solely with SingularityNET. SingularityNET,
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694807000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>, the </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694807000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        logo, and all other trademarks, service marks, graphics and logos used in
                        connection with{" "}
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694808000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        , or the Website are trademarks or registered trademarks of SingularityNET
                        or SingularityNET&rsquo;s licensors. Other trademarks, service marks,
                        graphics and logos used in connection with the Website may be the trademarks
                        of other third parties. Your use of the Website grants you no right or
                        license to reproduce or otherwise use any SingularityNET or third-party
                        trademarks.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2310&amp;sa=D&amp;ust=1563446694808000">
                        10. Attribution
                    </a>
                </h2>
                <p>
                    <span>
                        SingularityNET reserves the right to display attribution links such as
                        &lsquo;Powered by{" "}
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694809000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>,&rsquo; theme author, and font attribution in your content footer.</span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2311&amp;sa=D&amp;ust=1563446694809000">
                        11. Changes
                    </a>
                </h2>
                <p>
                    <span>
                        SingularityNET reserves the right, at its sole discretion, to modify or
                        replace any part of this Agreement. It is your responsibility to check this
                        Agreement periodically for changes. Your continued use of or access to the
                        Website following the posting of any changes to this Agreement constitutes
                        acceptance of those changes. SingularityNET may also, in the future, offer
                        new services and/or features through the Website (including, the release of
                        new tools and resources). Such new features and/or services shall be subject
                        to the terms and conditions of this Agreement.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2312&amp;sa=D&amp;ust=1563446694810000">
                        12. Termination
                    </a>
                </h2>
                <p>
                    <span>
                        SingularityNET may terminate your access to all or any part of the Website
                        at any time, with or without cause, with or without notice, effective
                        immediately. If you wish to terminate this Agreement or your
                    </span>
                    <span>
                        <a href="http://singularitynet.io/&amp;sa=D&amp;ust=1563446694811000">
                            SingularityNET.io
                        </a>
                    </span>
                    <span>
                        &nbsp;account (if you have one), you may simply discontinue using the
                        Website. All provisions of this Agreement which by their nature should
                        survive termination shall survive termination, including, without
                        limitation, ownership provisions, warranty disclaimers, indemnity and
                        limitations of liability.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2313&amp;sa=D&amp;ust=1563446694811000">
                        13. Disclaimer of Warranties
                    </a>
                </h2>
                <p>
                    <span>
                        The Website is provided &ldquo;as is&rdquo;. SingularityNET and its
                        suppliers and licensors hereby disclaim all warranties of any kind, express
                        or implied, including, without limitation, the warranties of
                        merchantability, fitness for a particular purpose and non-infringement.
                        Neither SingularityNET nor its suppliers and licensors, makes any warranty
                        that the Website will be error free or that access thereto will be
                        continuous or uninterrupted. If you&rsquo;re actually reading this,
                        here&rsquo;s
                    </span>
                    <span>
                        <a href="http://www.newyorker.com/online/blogs/shouts/2012/12/the-hundred-best-lists-of-all-time.html&amp;sa=D&amp;ust=1563446694812000">
                            a treat
                        </a>
                    </span>
                    <span>
                        . You understand that you download from, or otherwise obtain content or
                        services through, the Website at your own discretion and risk.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2314&amp;sa=D&amp;ust=1563446694812000">
                        14. Limitation of Liability
                    </a>
                </h2>
                <p>
                    <span>
                        In no event will SingularityNET, or its suppliers or licensors, be liable
                        with respect to any subject matter of this agreement under any contract,
                        negligence, strict liability or other legal or equitable theory for: (i) any
                        special, incidental or consequential damages; (ii) the cost of procurement
                        for substitute products or services; (iii) for interruption of use or loss
                        or corruption of data; or (iv) for any amounts that exceed the fees paid by
                        you to SingularityNET under this agreement during the twelve (12) month
                        period prior to the cause of action. SingularityNET shall have no liability
                        for any failure or delay due to matters beyond their reasonable control. The
                        foregoing shall not apply to the extent prohibited by applicable law.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2315&amp;sa=D&amp;ust=1563446694813000">
                        15. General Representation and Warranty
                    </a>
                </h2>
                <p>
                    <span>
                        You represent and warrant that (i) your use of the Website will be in strict
                        accordance with the SingularityNET
                    </span>
                    <span>
                        <a href="https://community.singularitynet.io/privacy&amp;sa=D&amp;ust=1563446694814000">
                            Privacy Policy
                        </a>
                    </span>
                    <span>, </span>
                    <span>
                        <a href="https://community.singularitynet.io/guidelines&amp;sa=D&amp;ust=1563446694814000">
                            Community Guidelines
                        </a>
                    </span>
                    <span>
                        , with this Agreement and with all applicable laws and regulations
                        (including without limitation any local laws or regulations in your country,
                        state, city, or other governmental area, regarding online conduct and
                        acceptable content, and including all applicable laws regarding the
                        transmission of technical data exported from the country in which this
                        website resides or the country in which you reside) and (ii) your use of the
                        Website will not infringe or misappropriate the intellectual property rights
                        of any third party.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2316&amp;sa=D&amp;ust=1563446694815000">
                        16. Indemnification
                    </a>
                </h2>
                <p>
                    <span>
                        You agree to indemnify and hold harmless SingularityNET, its contractors,
                        and its licensors, and their respective directors, officers, employees and
                        agents from and against any and all claims and expenses, including
                        attorneys&rsquo; fees, arising out of your use of the Website, including but
                        not limited to your violation of this Agreement.
                    </span>
                </p>
                <h2>
                    <a href="https://community.singularitynet.io/tos%2317&amp;sa=D&amp;ust=1563446694815000">
                        17. Miscellaneous
                    </a>
                </h2>
                <p>
                    <span>
                        This Agreement constitutes the entire agreement between SingularityNET and
                        you concerning the subject matter hereof, and they may only be modified by a
                        written amendment signed by an authorized executive of SingularityNET, or by
                        the posting by SingularityNET of a revised version. Except to the extent
                        applicable law, if any, provides otherwise, this Agreement, any access to or
                        use of the Website will be governed by the laws of the state of California,
                        U.S.A., excluding its conflict of law provisions, and the proper venue for
                        any disputes arising out of or relating to any of the same will be the state
                        and federal courts located in San Francisco County, California. Except for
                        claims for injunctive or equitable relief or claims regarding intellectual
                        property rights (which may be brought in any competent court without the
                        posting of a bond), any dispute arising under this Agreement shall be
                        finally settled in accordance with the Comprehensive Arbitration Rules of
                        the Judicial Arbitration and Mediation Service, Inc. (&ldquo;JAMS&rdquo;) by
                        three arbitrators appointed in accordance with such Rules. The arbitration
                        shall take place in San Francisco, California, in the English language and
                        the arbitral decision may be enforced in any court. The prevailing party in
                        any action or proceeding to enforce this Agreement shall be entitled to
                        costs and attorneys&rsquo; fees. If any part of this Agreement is held
                        invalid or unenforceable, that part will be construed to reflect the
                        parties&rsquo; original intent, and the remaining portions will remain in
                        full force and effect. A waiver by either party of any term or condition of
                        this Agreement or any breach thereof, in any one instance, will not waive
                        such term or condition or any subsequent breach thereof. You may assign your
                        rights under this Agreement to any party that consents to, and agrees to be
                        bound by, its terms and conditions; SingularityNET may assign its rights
                        under this Agreement without condition. This Agreement will be binding upon
                        and will inure to the benefit of the parties, their successors and permitted
                        assigns.&rsquo;
                    </span>
                </p>
            </body>
        </html>
    );
};

export default PrivacyTerms;
